<template>
  <v-container fluid>
    <v-row class="d-flex align-center justify-center mb-3 mt-5">
      <v-img max-height="42px" contain src="https://swiset.com/wp-content/uploads/2024/10/logo-2024-01-01.png"/>
    </v-row>
    <v-row style="min-height: 70vh !important;" align="center" justify="center">
      <router-view/>
    </v-row>
    <v-row class="pa-3" style="background-color: #EEEEEE" align="center" justify="center">
      <p class="my-0 text-center">{{ $t('phrase') }}<br>{{ $t('description') }}</p>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "VoteIndex",
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "phrase": "Awards powered by Swiset",
    "description": "An award winning trading app. Journal, Tournaments and Prop Simulations"
  },
  "es": {
    "phrase": "Premios traídos a ti por Swiset",
    "description": "Una suite de trading premiada. Journal, Torneos y Simulaciones de Prop"
  }
}
</i18n>
